import { DEFAULT_LAYOUT } from '@/router/base';

export default {
  path: '/search',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '全功能搜索',
    icon: 'SfTag',
    permission: ['*'],
    order: 0,
  },
  children: [
    {
      path: '',
      name: '/search',
      component: () => import(/* webpackChunkName:'search' */ '@/pages/search.vue'),
      meta: {
        title: '全功能搜索',
        permission: ['*'],
        activeMenu: '/search',
        hideInMenu: true,
      },
    },
  ],
};
